export enum AlertDialogType {
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  CONFIRM = 'CONFIRM',
}
